<template>
  <header>
    <div class="title" :class="isTag && 'tagSearch-title'">
      <input v-if="isTag" type="checkbox" :checked="selectedTag" @change="$emit('toggleSelectTag')" style="margin-right: 14px;">
      <h3 :class="isTag && 'tag-header-ellipsis'"
      >
        <router-link :to="{path: url, item}">{{ item.name || 'ID: ' + item.id }}</router-link>
        <span class="query-uid" @click="simpleCopy(item.id)">#{{item.id}}</span>
      </h3>
      <div class="actions" :class="isTag && 'vertical-actions'">
        <router-link :to="{path: url, item}">
          <i class="far fa-edit"/>
          <span v-if="!isTag">{{ $t('booleanSearch.edit') }}</span>
        </router-link>
        <div class="clone" @click="$emit('toggleClone')"><i class="far fa-copy"/><span v-if="!isTag">{{ $t('booleanSearch.select.clone') }}</span></div>

        <dropdownButton
            v-if="resourceType !== 'groups' && !isTag"
            :options="exportOptions"
            :icon="queryExporting && queryExporting === item.id ? 'fas fa-spinner rotate' : 'far fa-download'"
            :label="$t('booleanSearch.export')"
            :customCss="`search-export-dropdown ${queryExporting ? 'disabled' : ''}`"
            @exportCsv="exportSearches({ key: resourceName, item: item.id, formatType: 'csv' })"
            @exportXls="exportSearches({ key: resourceName, item: item.id, formatType: 'xlsx' })"
        >
        </dropdownButton>

        <div class="remove" @click="() => { showDeleteConfirmation = true; }">
          <i class="far fa-trash-alt"/>
          <span v-if="!isTag">{{ $t('booleanSearch.select.delete') }}</span>
        </div>

        <div v-if="isTag" class="visible" @click="() => { showChangeVisibilityConfirmation = true; }">
          <i v-if="showPrivateTags" :class="item.is_private ? 'far fa-eye-slash' : 'far fa-eye'"/>
        </div>

      </div>
    </div>

    <div class="authorWrapper">
      <span v-if="item.created_by">
        <span>Created By</span>
        <span class="author">{{item.created_by}} - </span>
      </span>
      <span>
        <span v-if="searchTypeLabel">{{searchTypeLabel}} |</span>
        <span v-if="!isTag" class="createdAt">{{createdAt}}</span>
      </span>

      <span v-if="isTag" class="tag-date">{{createdAt}}</span>

    </div>
    <div v-if="item.description" class="description">{{item.description}}</div>

    <confirmation-modal v-if="showDeleteConfirmation || showChangeVisibilityConfirmation"
      :headerText="showChangeVisibilityConfirmation ? $t('messages.tags.change_visibility.title') : $t('messages.confirm_delete.title')"
      :message="showChangeVisibilityConfirmation ? 
        $t(`messages.tags.change_visibility.${item.is_private ? 'public' : 'private'}`, [item.name]) : 
        $t('messages.confirm_delete.message', [item.name])"
      :showDeleteButton="showChangeVisibilityConfirmation ? false : true"
      @confirmAction="() => showChangeVisibilityConfirmation ? changeVisibility() : deleteItem()"
      @cancelAction="() => { showDeleteConfirmation = false; showChangeVisibilityConfirmation = false }"
      :disableConfirmButton="disableConfirmButton"
    />
  </header>
</template>

<script>
// Const
import { searchTypes } from '../../../../config/bool-const'
// Plugins
import { mapState, mapActions } from 'vuex';
import moment from 'moment';

// Mixins
import remove from '../../../../mixins/boolean-search/delete.js'
import simpleCopy from "../../../../mixins/boolean-search/simpleCopy";
import exportSearches from '../../../../mixins/boolean-search/export';
import notifyMessages from '../../../../mixins/boolean-search/notifyMessages';

// Components
import confirmationModal from '../../../confirmation-modal';
import dropdownButton from '../../../dropdown-button';

export default {
  name: "QueryListItemHeader",
  props: {
    resourceName: {
      type: String,
      required: true
    },
    item: {
      type: Object,
      required: true
    },
    color: {
      type: String
    },
    selectedTag: {
      type: Boolean,
    },
    showPrivateTags: {
      type: Boolean,
      default: false
    },
  },

  mixins: [ remove, simpleCopy, exportSearches, notifyMessages ],

  data() {
    return {
      showDeleteConfirmation: false,
      showChangeVisibilityConfirmation: false,
      disableConfirmButton: false
    }
  },

  computed: {
    ...mapState({
      queryExporting: state => state.booleanSearch.searches.queryExporting
    }),
    client_id() { return this.$store.state.booleanSearch.client_id },
    project_id() { return this.$store.state.booleanSearch.project_id },
    resourceType() {
      return this.resourceName === 'group_library' ? 'groups' : this.resourceName === 'tag_library' ? 'tagsSearches' : this.resourceName;
    },
    url() {
      let url = `/clients/${this.client_id}/projects/${this.project_id}`
      if(this.resourceName === 'tag_library'){
        url += `/tags/${this.item.id}`
      } else if (this.resourceName === 'group_library') {
        url +=  `/searches/group_library/${this.item.id}`}
      else {
        url += `/searches/${this.item.id}`
      }
      return url;
    },
    createdAt() { return moment(this.item.created_at).format('Do MMMM YYYY');},
    searchTypeObj() {
      if (this.item.is_multi && Array.isArray(this.item.search_type)) {
        return searchTypes.filter(type => this.item.search_type.includes(type.value));
      } else {
        return this.item.search_type && searchTypes.find(type => type.value === this.item.search_type);
      }
    },
    searchTypeLabel() {
      if (Array.isArray(this.searchTypeObj)) {
        return this.$t('booleanSearch.search_type.multi') + ': ' + this.searchTypeObj.map(type => type.label).join(', ');
      } else {
        return this.searchTypeObj ? this.searchTypeObj.label : '';
      }
    },
    exportOptions() {
      return [
        { label: 'Export CSV', action: 'exportCsv' },
        { label: 'Export Excel', action: 'exportXls' },
      ]
    },
    isTag(){
      return this.resourceName === 'tag_library' || this.resourceName === 'tagsSearches' || this.resourceType === 'tagsSearches'
    }
  },

  methods: {
    ...mapActions({
      changeTagsVisibility: 'booleanSearch/changeTagsVisibility'
    }),
    deleteItem () {
      this.$store.commit('booleanSearch/SET_DELETING', {key: this.resourceName, item: this.item})
      this.showDeleteConfirmation = false;
      this.remove({ key: this.resourceName, item: this.item })
      .finally(() => this.$store.commit('booleanSearch/SET_DELETING', {key: this.resourceName, item: null}));
    },
    changeVisibility() {
      this.disableConfirmButton = true;
      this.changeTagsVisibility({ tagsIds: [this.item.id], visible: this.item.is_private, projectId: this.project_id})
        .then(() => {
          this.showChangeVisibilityConfirmation = false;
          this.notifyStoreSuccess(this.$t('booleanSearch.changed_visibility'));
        })
        .catch(() => {
          this.notifyStoreError(this.$t('booleanSearch.err_changing_visibility'));
        })
        .finally(() => {
          this.disableConfirmButton = false;
        })
    }
  },

  components: {
    confirmationModal,
    dropdownButton
  }
}
</script>

<style scoped>
  .tag-date{
    position: absolute; 
    bottom: 0;
  }
</style>